import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// import get from "lodash/get";

import { withT } from "services/translation/";

import PageLayout from "./PageLayout";

import Loading from "components/Loading";

import { getEnterpriseFromRoute } from "services/redux/selectors";

import { getRouterParams } from "services/redux/selectors/app/";

import {
  loadOutstandingReportStart,
  loadOutstandingReportCancel
} from "services/redux/actions";

import {
  getOutstandingReport,
  getPairBundles
} from "services/redux/selectors/reports/outstanding/";

class OutstandingIndexReportPage extends React.Component {
  // Loads report when enterprises are available so we can load root group
  loadReport(props) {
    let { enterprise_id, group_id } = props.router.params;
    const { enterprise } = props;

    // The root group was specified - we need to wait on loading
    //  enterprises to get the root group id before we can
    //  begin our request
    if (group_id === "root" || !group_id) {
      group_id = enterprise && enterprise.root_group_id;
      // No enterprises loaded yet
      if (!group_id) return;
    }

    const params = {
      enterprise_id,
      group_id,
      interval: 1 * 60 * 1000,
      refresh: true
      // key: "index"
    };

    this.props.dispatch(loadOutstandingReportStart(params));
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { loading } = this.props;
    const { params } = this.props.router;
    const nextParams = nextProps.router.params;

    const propsChanged =
      params.enterprise_id !== nextParams.enterprise_id ||
      params.group_id !== nextParams.group_id;

    if (propsChanged) {
      // Not initial load - cancel any previous
      //   live refresh
      if (loading !== null) {
        this.props.dispatch(loadOutstandingReportCancel());
      }
      this.loadReport(nextProps);
    }
  }
  componentWillMount() {
    // Scroll to the top
    // window.scrollTo(0, 0);
    this.loadReport(this.props);
  }
  componentWillUnmount() {
    // Cancel any live report auto refresh
    this.props.dispatch(loadOutstandingReportCancel());
  }
  render() {
    // const { report, enterprise, eventMetaLoading, pair_bundles } = this.props;
    const { report, enterprise, eventMetaLoading } = this.props;
    // Loading indicator on first load
    const loadingOverlay = report.loading !== false ? "loading" : "";

    // const eventPairsAvailable = get(pair_bundles, "0.event_pairs");

    const loading =
      // Show page when report has finished loading
      report.loading === null ||
      (report.loading === true && report.nextRefresh === null) ||
      // Show page when event meta has been loaded
      eventMetaLoading !== false ||
      // // No event pairs
      // !eventPairsAvailable ||
      !enterprise;

    return loading
      ? <div>
          <div className="page-title-box pt-0">
            <div className="col-md-4 text-center text-sm-left">
              <h4 className="page-title mb-2 mt-0">{this.props.t("title")}</h4>
              <div className="text-muted font-14 mb-2">{this.props.t("description")}</div>
              <Loading />
            </div>
            
          </div>
        </div>
      : <PageLayout className={loadingOverlay} />;
  }
}
OutstandingIndexReportPage.propTypes = {
  enterprise: PropTypes.object,
  router: PropTypes.object,
  report: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => {
  const outstandingReport = getOutstandingReport(state, props);
  return {
    enterprise: getEnterpriseFromRoute(state, props),
    // outstanding: state.reports.outstanding,
    report: outstandingReport,
    pair_bundles: getPairBundles(state, props),
    eventMetaLoading: state.eventMeta.loading,
    router: { params: getRouterParams(state, props) }
  };
};
export default withT(connect(mapStateToProps)(OutstandingIndexReportPage), "reports.outstanding.index");
